import axios from "../axios-auth";

export const maintenanceFrequencyService = {
    getMaintenanceFrequencyList,
    saveMaintenanceFrequency,
    getMaintenanceFrequencyDetail,
    getMaintenanceFrequencyByStatus,
}

function getMaintenanceFrequencyList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/maintenance-frequencies", { params });
}

function saveMaintenanceFrequency(maintenanceFrequency) {
    if (!maintenanceFrequency.id) {
        // new
        return axios.post("/auth/maintenance-frequency", maintenanceFrequency);
    } else {
        // edit
        return axios.put("/auth/maintenance-frequency", maintenanceFrequency);
    }
}

function getMaintenanceFrequencyDetail(id) {
    return axios.get("/auth/maintenance-frequency/" + id);
}

function getMaintenanceFrequencyByStatus(status) {
    return axios.get("/auth/maintenance-frequencies-by-status/" + status);
}